import styled from 'styled-components';
import { mobileQuery } from '../../../utils';
import { tabStore } from '../../../store/tabStore';
import { MAIN_TAB_STATUS, SUB_TAB_STATUS } from '../../../types/type';

export const End = ({ isMain = true, isEarlyEnd }: { isMain: boolean; isEarlyEnd?: boolean }) => {
  const { setSubTab, setMainTab } = tabStore();

  return (
    <>
      <EndContainer>
        {isEarlyEnd && <EndTopText>많은 참여로 인한 참가 티켓 소진으로</EndTopText>}
        <EndText $earlyEnd={isEarlyEnd}>
          새틀라이트가
          <br />
          {isEarlyEnd ? '조기 ' : ''}종료되었습니다.
        </EndText>
        <EndTextContainer>
          <EndSubText>
            3분기 중 다음 토너먼트를
            <br />
            준비하고 있으니 많은 기대부탁드립니다!
          </EndSubText>
        </EndTextContainer>
        <EndSubText $isBottom={true}>
          참가권을 획득하신분들은
          <br />
          <span>오프라인 이벤트 탭으로 이동</span> 하여
          <br />
          토너먼트 정보를 확인해주세요!
        </EndSubText>
      </EndContainer>
      <BottomTabContainer
        onClick={() => {
          setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
          setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_OFFLINE);
        }}
      >
        <GoTournamentBtn $isMain={isMain}>오프라인 이벤트 참가 안내 확인하기</GoTournamentBtn>
      </BottomTabContainer>
    </>
  );
};

const EndTextContainer = styled.div`
  border-radius: 10px;
  border: 1px solid #0d0d0d;
  background: rgba(0, 0, 0, 0.3);

  padding: 8px 5px 9px 5px;
  max-width: 800px;
  margin: 0 auto;
  margin-bottom: 10px;

  ${mobileQuery} {
    max-width: 380px;
  }
`;

const EndSubText = styled.h4<{ $isBottom?: boolean }>`
  color: ${({ $isBottom }) =>
    $isBottom ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.4)'};
  text-align: center;
  font-size: 32px;
  line-height: 48px;
  font-weight: 300;
  letter-spacing: -0.92px;

  span {
    color: #fff1c9;
    border-bottom: 1px solid #fff1c9;
  }

  ${mobileQuery} {
    font-size: 14px;
    line-height: 22px;
  }
`;

const EndTopText = styled.h4`
  font-weight: 500;
  font-size: 32px;
  line-height: 36px;
  letter-spacing: -0.02em;
  color: #b54b4b;
  text-align: center;

  ${mobileQuery} {
    font-size: 16px;
    line-height: 18px;
  }
`;

const EndText = styled.h3<{ $earlyEnd?: boolean }>`
  color: ${({ $earlyEnd }) => ($earlyEnd ? '#FF6062' : '#d3d3d3')};
  text-align: center;
  font-weight: 400;
  font-size: 64px;
  line-height: 70px;
  letter-spacing: -1.9px;
  margin-bottom: 30px;

  ${mobileQuery} {
    font-size: 25px;
    line-height: 32px;
  }
`;

const EndContainer = styled.div`
  padding-top: 35px;
  flex: 1;
  padding-bottom: 100px;
  padding-left: 10px;
  padding-right: 10px;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const GoTournamentBtn = styled.button<{ $isMain: boolean }>`
  left: 30%;
  height: 70px;
  width: 100%;
  cursor: pointer;
  ${({ $isMain }) =>
    $isMain
      ? `
box-shadow: 0px 1px 0px 0px rgba(255, 183, 183, 0.3) inset;
background: linear-gradient(90deg, rgba(182, 0, 88, 0.85) 39.5%, rgba(174, 11, 114, 0.85) 100%);
backdrop-filter: blur(25px);`
      : `
background: linear-gradient(106deg, rgba(5, 91, 219, 0.90) -5.91%, rgba(16, 65, 139, 0.90) 72.35%);
box-shadow: 0px 1px 0px 0px rgba(31, 240, 255, 0.10) inset;
backdrop-filter: blur(30px);`}

  font-weight: 600;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;
